import { postRequest } from 'servos/apiRequests'

export const postMessage = (data, onSuccess, onFailure) => {
  let url = '/confirm_eligibility'
  postRequest({ url, data, onSuccess, onFailure })
}
